webpackJsonp([103361948909695],{

/***/ 771:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Quickstart = __webpack_require__(9);
	
	var _Quickstart2 = _interopRequireDefault(_Quickstart);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _final = __webpack_require__(99);
	
	var _final2 = _interopRequireDefault(_final);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Quickstart2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Step 3: Run the Application'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'With the dependencies installed, run the application by typing ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'npm start'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      $ npm start\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'A successful execution will produce output similar to this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      webpack-dev-server --hot --env.webpack=development --env.lore=development\n\n      build [==                  ] 10%\n      Project is running at http://localhost:3000/\n\n      webpack output is served from /\n      404s will fallback to /index.html\n\n      Build completed in 6.541s\n\n      Hash: 199de1b7032b223700a9\n      Version: webpack 3.12.0\n      Time: 6712ms\n\n                       Asset   Size       Chunks                    Chunk Names\n        favicons/favicon.ico   33.3 kB            [emitted]\n       favicon-manifest.json   613 bytes          [emitted]\n      assets/images/logo.png   27.7 kB            [emitted]\n              bundle.main.js   3.16 MB         0  [emitted]  [big]  main\n            bundle.vendor.js   1.27 MB         1  [emitted]  [big]  vendor\n                  index.html   4.41 kB            [emitted]\n\n      ...\n\n      webpack: Compiled successfully.\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This step invokes ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://webpack.github.io/' },
	        'Webpack'
	      ),
	      ' to build the application and starts a development server so you can view it in the browser.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'You can learn more about Lore\'s webpack config ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/anatomy/webpack-config/' },
	          'here'
	        ),
	        '.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'View the Application'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Once the application is built, you can view it by navigating to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'http://localhost:3000'
	      ),
	      '. Once you do, you should see this:'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _final2.default }),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'If you want to change the port the webpack dev server runs on, you can learn how to do that ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/anatomy/package/' },
	          'here'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'However, if you plan on following along with this Quickstart, it is strongly recommended that you ',
	        _react2.default.createElement(
	          'strong',
	          null,
	          'do not change the port'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Later in the Quickstart we\'ll be integrating with a real authentication server, and the application will need to be running on port 3000 to do so.'
	      )
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-4/' },
	        'setup the mock API server'
	      ),
	      ' we\'ll be using for this Quickstart.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-quickstart-setup-step-3-js-4407e64d5daf35594779.js